import { getPhase } from "helpers/rsc";

export function isSection(rsc, section) {
    return rsc?.slice(-4, -2) === section;
}

export function isLaser(rsc) {
    return rsc?.slice(-4, -2) === 'LR';
}

export function isSwiming(rsc) {
    return rsc?.slice(-4, -2) === 'SW';
}

export function isEquestrian(rsc) {
    return rsc?.slice(-4, -2) === 'EQ';
}

export function isFencing(rsc) {
    return rsc?.slice(-4, -2) === 'FE';
}

export function isFencingRR(rsc) {
    return isFencing(rsc) && getPhase(rsc) === 'RANK';
}

export function isFencingBR(rsc) {
    return isFencing(rsc) && getPhase(rsc) !== 'RANK';
}

export function prepareRscForCumulative(rsc) {

    if (isSemifinals(rsc) || isQualification(rsc)) {
        return  rsc?.slice(0, 26) +'000' + rsc?.slice(-5, -4) + '00--' 
    }

    return rsc?.slice(0, 22) + 'FNL---------';
}

export function prepareRscForCumulativeSemifinals(rsc) {
    return rsc?.slice(0,22) + 'SFNL--------';
}                              

export function prepareRscForCumulativeFencing(rsc) {
    if (isSemifinals(rsc)) {
        return  rsc?.slice(0, 26) +'000' + rsc?.slice(-5, -4) + 'FE--' 
    }
    return rsc?.slice(0, 22) + 'FNL-0001FE--';
}

export function prepareRscForCumulativeTeam3(rsc) {
    if(rsc?.includes('INDIVID-----------FNL-0001LR--')) {
        return rsc?.slice(0,4) + 'TEAM3-------------FNL---------';
    }

    if (isSemifinals(rsc) || isQualification(rsc)) {
        return  rsc?.slice(0, 26) +'000' + rsc?.slice(-5, -4) + '00--' 
    }

    return rsc?.slice(0, 22) + 'FNL---------';

}

export function isQualification(rsc) {
    return rsc?.slice(22, 26) === 'QUAL';
}

export function isFinal(rsc) {
    return rsc?.slice(22, 26) === 'FNL-';
}

export function isSemifinals(rsc) {
    return rsc?.slice(22, 26) === 'SFNL';
}

export function isQualifications(rsc) {
    return rsc?.slice(22, 26) === 'QUAL';
}

export function prepareRscForPhase(rsc) {
    if(isQualifications(rsc)) {
        return  rsc?.slice(0, 26) +'000' + rsc?.slice(-5, -4) + 'SW--' 
    }
    if (isSemifinals(rsc)) {
        return  rsc?.slice(0, 26) +'000' + rsc?.slice(-5, -4) + 'SW--' 
    }
    return rsc?.slice(0, 22) + 'FNL---------';
}

export function prepareRscForFinishedPhase(rsc) {
    if (isSemifinals(rsc) || isFencingRR(rsc)) {
        return rsc?.slice(0, 22) + 'SFNL0002LR--'
    }
    return rsc?.slice(0, 22) + 'FNL-0002LR--';
}

export function isTeam(rsc) {
    return rsc?.includes('TEAM')
}

export function isMixedTeam(rsc) {
    return rsc?.includes('XTEAM')
}

